/* eslint-disable react-hooks/exhaustive-deps */
import { Grid, makeStyles } from "@material-ui/core/";
import React, { useContext, useState, useEffect } from "react";
import { config as url } from "../../common/config";
import FetchDataContext from "../../context/fetchData/fetchDataContext";
import OptionHandle from "./OptionHandle";
import TableOnLog from "./TableOnLog";
import moment from "moment";

const useStyles = makeStyles((theme) => ({
	root: {
		paddingLeft: "2rem",
		paddingRight: "2rem",
		[theme.breakpoints.down("sm")]: {
			paddingLeft: "1rem",
			paddingRight: "1rem",
		},
	},
}));

const Logs = () => {
	const classes = useStyles();
	const BaseUrl = `${url.log}`;
	const fetchData = useContext(FetchDataContext);
	const {
		getDataTables,
		refreshData,
		tableRef,
		stateOption,
		SingleHandleOptions,
		singleOption,
	} = fetchData;

	const [state] = useState({
		pageSize: 10,
	});
	const [optionChange, setOptionChange] = useState({
		tanggal: moment().format("YYYY-MM-DD"),
		iduser: 0,
	});

	useEffect(() => {
		SingleHandleOptions({
			path: "user",
		});
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [optionChange.iduser]);

	return (
		<Grid direction="column" alignItems="center" className={classes.root}>
			<OptionHandle
				stateOption={stateOption && stateOption}
				state={optionChange}
				setState={setOptionChange}
				handleSearch={refreshData}
				SingleHandleOptions={SingleHandleOptions}
				singleOption={singleOption}
			/>
			<TableOnLog
				getDataTables={getDataTables}
				BaseUrl={BaseUrl}
				pageSize={state.pageSize}
				tableRef={tableRef}
				state={optionChange}
			/>
		</Grid>
	);
};
export default Logs;
